let host = 'https://beta.labyouth.com'

export default {
	detail: `${host}/api/p/products/`,
}

export {
	host
}
